export const getRectFromCoordinates = (coordinates) => {
    if ("width" in coordinates && coordinates.width !== undefined)
        return coordinates;
    return {
        ...coordinates,
        width: 0,
        height: 0,
        left: coordinates.x,
        right: coordinates.x,
        top: coordinates.y,
        bottom: coordinates.y,
        toJSON: () => { },
    };
};
